import { RemarksModalMode } from '@/components/RemarksModal/RemarksModal.types';
import { DigiDocuProcessingStep } from '@/helpers/getCurrentDigitalizationDocumentProcessingStep';
import { DocuProcessingStep } from '@/helpers/getCurrentDocumentProcessingStep';
import { Route } from '@/routes';
import { CheckPropertyValidationErrorType } from '@/services/check-bot/CheckBotConfigsService';
import { ErrorType } from '@/views/ErrorView/ErrorView.types';
import { WorkspaceDetailsTab } from '@/views/WorkspaceDetails/WorkspaceDetails.types';
import {
  ACTOR_APP,
  CheckBotInferenceStatus,
  CheckBotModuleStrings,
  CheckbotStatusEnum,
  DigitalizationCheckBotStatus,
  DigitalizationFormalControlStatus,
  DigitalizationProjectStatus,
  DocumentEvent,
  DocumentStatus,
  FailureReason,
  FileStatus,
  FormalControlStatus,
  IblImportErrorType,
  IblImportWarningType,
  InspectorStatusEnum,
  MetadataCheckStatus,
  MetadataInspectionStatus,
  MissingResourceType,
  ProjectStatus,
  ProjectType,
  QualityCheckStatus,
  RecordLibraryTransferStatus,
  Role,
  SupplierDocumentStatus,
  VgbmAssignmentQuality,
  WebTour,
  WorkflowStatus,
  WorkspaceDocumentInvolvementType,
  WorkspaceStatus,
} from 'types';
import { UploadType } from '../components/MassUploadTable/MassUploadTable.types';

export default {
  generic: {
    placeholder: 'Placeholder',
    notImplemented: 'Not implemented',
    firstName: 'First name',
    lastName: 'Last name',
    supplier: 'Supplier | Suppliers',
    email: 'Email',
    contentType: 'Contenttyp',
    uploadDate: 'Upload date',
    inspectionDueDate: 'Inspection due date',
    inspection: 'Formal exam.',
    inspectorStatus: 'Technical exam.',
    metadataInference: 'AI proposals',
    metadataInspection: 'Metadata inspection',
    qualityCheck: 'Quality check',
    qualityCheckAbbreviated: 'Quality check',
    documentId: 'Document ID',
    documentIdAbbreviated: 'Doc.',
    administration: 'Administration',
    docuManager: 'Dokumenten-Manager',
    saveChanges: 'Save changes',
    cancel: 'Cancel',
    ok: 'Ok',
    document: 'Document',
    apply: 'Apply',
    warning: 'Warning',
    selectFile: 'Select file',
    selectFileOrDragAndDrop: 'Select file or drag and drop',
    dropFileHere: 'Drop file here',
    noFileSelected: 'No file selected.',
    upload: 'Upload',
    count: 'Count',
    search: 'Search',
    noDataFound: 'No data found',
    filter: 'Filter',
    loadMore: 'Load more',
    create: 'Create',
    settings: 'Settings',

    suppliers: 'Suppliers',
    coworkers: 'Coworkers',
    goBack: 'Go back',
    project: 'Project',
    projects: 'Projects',
    coworker: 'Coworker',
    save: 'Save',
    add: 'Add',
    close: 'Close',
    select: 'Select',
    removeAllFilters: 'Remove all filters',
    resetAllFilters: 'Reset all filters',
    clear: 'clear',
    showAll: 'Show all',
    selectedItems: 'Selected: {count}',
    recordLibraryTransfer: 'Record library transfer',
    yes: 'yes',
    no: 'no',
    forExample: 'E.g.',
    success: 'Success',

    selectOption: 'Select option',

    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },

    days: {
      monday: 'M',
      tuesday: 'T',
      wednesday: 'W',
      thursday: 'T',
      friday: 'F',
      saturday: 'S',
      sunday: 'S',
    },

    booleanYesNo: {
      true: 'Yes',
      false: 'No',
    },
  },

  errors: {
    error: 'An error occured',
  },

  app: {
    logOutReminder: 'Remember to log out before closing this window',
  },

  commonProjects: {
    errors: {
      errorLoadingProjectData: 'An error occured while loading project data.',
    },
  },

  checkBotStatus: {
    [CheckbotStatusEnum.ok]: 'Accepted',
    [CheckbotStatusEnum.waiting]: 'In progress',
    [CheckbotStatusEnum.critical]: 'Rejected',
    [CheckbotStatusEnum.info]: 'Accepted',
    [CheckbotStatusEnum.error]: 'Rejected',
    [CheckbotStatusEnum.timedOut]: 'Timeout',
    [CheckbotStatusEnum.warning]: 'Accepted with remarks',
    [CheckbotStatusEnum.failed]: 'Check failed',
  },

  formalControlStatus: {
    [FormalControlStatus.ACCEPTED]: 'Accepted',
    [FormalControlStatus.ACCEPTED_WITH_REMARKS]: 'Accepted with remarks',
    [FormalControlStatus.REJECTED]: 'Rejected',
    [FormalControlStatus.WAITING]: 'In progress',
  },

  digitalizationFormalControlStatus: {
    [DigitalizationFormalControlStatus.ACCEPTED]: 'Accepted',
    [DigitalizationFormalControlStatus.ACCEPTED_WITH_REMARKS]:
      'Accepted with remarks',
    [DigitalizationFormalControlStatus.REJECTED]: 'Rejected',
    [DigitalizationFormalControlStatus.WAITING]: 'In progress',
    [DigitalizationFormalControlStatus.WAITING_FOR_METADATA_CHECK]:
      'Waiting for metadata inspection',
  },

  inspectorStatus: {
    [InspectorStatusEnum.accepted]: 'Accepted',
    [InspectorStatusEnum.acceptedWithRemarks]: 'Accepted with remarks',
    [InspectorStatusEnum.timedOut]: 'Inspection due date exceeded',
    [InspectorStatusEnum.waiting]: 'In progress',
    [InspectorStatusEnum.rejected]: 'Rejected',
    [InspectorStatusEnum.waitingForFormalControl]: '-',
  },

  metadataCheckStatus: {
    [MetadataCheckStatus.FAILED]: 'Rejected',
    [MetadataCheckStatus.ACCEPTED]: 'Accepted',
  },

  fileStatus: {
    [FileStatus.waitingForFormalControl]: 'Waiting for formal control',
    [FileStatus.waitingForContentControl]: 'Waiting for content control',
    [FileStatus.rejected]: 'Rejected',
    [FileStatus.accepted]: 'Accepted',
    [FileStatus.acceptedWithRemarks]: 'Accepted with remarks',
  },

  recordLibraryTransferStatus: {
    [RecordLibraryTransferStatus.SUCCESSFULL]: 'Successfull',
    [RecordLibraryTransferStatus.FAILED]: 'Failed',
    [RecordLibraryTransferStatus.AWAITING_INSPECTIONS_COMPLETION]: '-',
  },

  checkBotInferenceStatus: {
    [CheckBotInferenceStatus.FAILED]: 'Failed',
    [CheckBotInferenceStatus.CHECK_BOT_INFERENCE_DISABLED]: 'Deactivated',
    [CheckBotInferenceStatus.WAITING]: 'Waiting',
    [CheckBotInferenceStatus.PENDING]: 'Pending',
    [CheckBotInferenceStatus.PROCESSING]: 'Processing',
    [CheckBotInferenceStatus.DATA_RECEIVED]: 'Received',
  },

  digitalizationCheckBotStatus: {
    [DigitalizationCheckBotStatus.OK]: 'OK',
    [DigitalizationCheckBotStatus.CRITICAL]: 'Critical',
    [DigitalizationCheckBotStatus.ERROR]: 'Error',
    [DigitalizationCheckBotStatus.WARNING]: 'Warning',
    [DigitalizationCheckBotStatus.INFO]: 'Info',
    [DigitalizationCheckBotStatus.TIMED_OUT]: 'Timed out',
    [DigitalizationCheckBotStatus.WAITING_FOR_METADATA_INSPECTION]:
      'Waiting for metadata inference',
    [DigitalizationCheckBotStatus.CHECK_BOT_INSPECTION_DISABLED]: 'Deactivated',
    [DigitalizationCheckBotStatus.FAILED]: 'Failed',
    [DigitalizationCheckBotStatus.WAITING]: 'Waiting',
  },

  metadataInspectionStatus: {
    [MetadataInspectionStatus.WAITING]: 'In progress',
    [MetadataInspectionStatus.ACCEPTED]: 'Accepted',
    [MetadataInspectionStatus.REJECTED]: 'Rejected',
  },

  qualityCheckStatus: {
    [QualityCheckStatus.WAITING_FOR_FORMAL_CONTROL]:
      'Waiting for formal control',
    [QualityCheckStatus.WAITING]: 'In progress',
    [QualityCheckStatus.ACCEPTED]: 'Accepted',
    [QualityCheckStatus.REJECTED]: 'Rejected',
  },

  digitalizationDocumentStatus: {
    [DocumentStatus.METADATA_INSPECTION]: '@:generic.metadataInspection',
    [DocumentStatus.FORMAL_CONTROL]: 'Formal control',
    [DocumentStatus.QUALITY_CHECK]: '@:generic.qualityCheck',
    [DocumentStatus.RECORD_LIBRARY_TRANSFER_IN_PROGRESS]: 'Transfer to Daisy',
    [DocumentStatus.RECORD_LIBRARY_TRANSFER_FAILED]: 'Transfer to Daisy failed',
    [DocumentStatus.RECORD_LIBRARY_TRANSFER_SUCCESSFULL]: 'Completed',
  },

  roles: {
    [Role.Admin]: 'Administrator | Administrators',
    [Role.DocuManager]: 'Document manager | document managers',
    [Role.Inspector]: 'Inspector | Inspectors',
    [Role.Coworker]: 'Coworker | Coworkers',
    [Role.DocuResponsible]: 'Docu responsible | Docu responsibles',
    [Role.DigitalizationCoworker]:
      'Digitalization coworker | Digitalization coworkers',
    [Role.WorkspaceOwner]: 'Workspace owner | Workspace owners',
    [Role.WorkspaceCoworker]: 'Workspace coworker | Workspace coworkers',
    [Role.Reviewer]: 'Reviewer | Reviewers',
  },

  breadCrumb: {
    [Route.PROJECTS_LIST]: 'Projects list',
    createProject: 'Create project',
    projectDetails: 'Project details',
    contentTypeConfiguration: 'Import configuration',
    addDocuManagerToProject: 'Add document manager to project',
    addCoworkerToProject: 'Add coworker to project',
    addSupplierToProject: 'Add supplier to project',
    documentUpload: 'Documents upload',
    documentDetailView: 'Document detail view',
    uploadReferenceNumber: 'Upload',
    digitalizationUploadReferenceNumber: 'Upload',
    suppliersList: 'Suppliers list',
    [Route.SUPPLIER_DETAILS]: 'Supplier details',
    coworkerDetails: 'Coworker details',
    administration: 'Administration',
    docuManagerDetailView: 'Document manager details',
    appConfig: 'App configuration',
    checkBotConfigurator: 'Check Bot Configurator',
    digitalizationProjectsList: 'Internal projects list',
    createDigitalizationProject: 'Create internal project',
    digitalizationProjectDetails: 'Internal project details',
    [Route.METADATA_GRID_EDITOR]: 'Metadata mass editor',
    [Route.UPLOAD_UPDATE]: 'Upload update',
    [Route.WORKSPACES_LIST]: 'Workspaces list',
    [Route.CREATE_WORKSPACE]: 'Create workspace',
    [Route.WORKSPACE_DETAILS]: 'Workspace details',
  },

  navBar: {
    header: 'SP Documentation Portal',
    suppliers: 'Supplier management',
    projects: 'Projects',
    administration: 'Administration',
    digitalizationProjects: 'Internal projects',
    docuResponsibleHelpPage: 'Help page for document responsibles',
    digitalizationCoworkerHelpPage: 'Help page for digitalization coworkers',
    workspaces: 'Workspaces',
  },

  filterableTable: {
    filter: 'Filter',
    entriesPerPage: 'Entries per page',
    filterBy: 'Filter by {field}',
    all: 'All',
    resetAllFilters: 'Remove all filters',
  },

  projectsList: {
    projects: 'Projects',
    title: 'Title',
    number: 'Number',
    status: 'Status',
    projectTitle: 'Title',
    projectNumber: 'Number',
    projectStatus: 'Status',
    fileStatuses: 'File statuses',
    addProject: 'Add project',
    errors: {
      couldNotLoadProjects: 'An error occured while loading projects',
    },
    description:
      'Welcome to our project overview and management! ' +
      'Here you can centrally manage and organize all information ' +
      'and progress of your projects to ensure efficient and ' +
      'successful project implementation.',
    active: 'active',
    inactive: 'inactive',
  },

  suppliersList: {
    suppliers: 'Suppliers',
    name: 'Name',
    SAPNumber: 'SAP-No.',
    coworkers: 'Coworkers',
    description:
      'Welcome to our supplier overview and management! ' +
      'Here you can bring together all information about ' +
      'your suppliers in one place.',
    errors: {
      couldNotLoadSuppliers:
        'An error occured while loading the suppliers list.',
    },
  },

  projectDetails: {
    project: 'Project',
    goToProjectRoom: 'Go to project room',
    tabs: {
      settings: 'Settings',
      suppliers: 'Suppliers',
      coworkers: 'Coworkers',
      contentTypes: 'Content types',
      deliveries: 'Deliveries',
      documents: 'Documents',
      ibl: 'IBL',
    },

    contentTypes: {
      contentTypes: '@:projectDetails.tabs.contentTypes',
      contentTypeName: 'Name',
      supplierName: 'Supplier',
      addContentType: 'Add content type',
      selectContentType: 'Content type',
      selectSupplier: 'Select supplier',
      errors: {
        noContentTypeSelected: 'No content type was selected',
        noSupplierSelected: 'No supplier was selected',
      },
      uploadCount: 'Uploads',
    },

    documents: {
      documents: '@:projectDetails.tabs.documents',
      documentId: '@:generic.documentId',
      supplierName: '@:generic.supplier',
      contentType: '@:generic.contentType',
      uploadDate: '@:generic.uploadDate',
      inspectionDueDate: '@:generic.inspectionDueDate',
      coworker: '@:generic.coworker',
      checkBotStatus: '@:generic.inspection',
      inspectorStatus: '@:generic.inspectorStatus',
      revision: 'Rev.',
      referenceNumber: 'Reference no.',
      rejectDocuments: 'Reject documents',
      acceptDocuments: 'Accept documents',
      errors: {
        couldNotLoadDocuments: 'An error occured while loading documents',
      },
      selectAll: 'Select all documents',
      deselectAll: 'Deselect all documents',
      documentProcessingStatus: 'Processing status',

      [CheckbotStatusEnum.ok]: `@:checkBotStatus.${CheckbotStatusEnum.ok}`,
      [CheckbotStatusEnum.waiting]: `@:checkBotStatus.${CheckbotStatusEnum.waiting}`,
      [CheckbotStatusEnum.critical]: `@:checkBotStatus.${CheckbotStatusEnum.critical}`,
      [CheckbotStatusEnum.info]: `@:checkBotStatus.${CheckbotStatusEnum.info}`,
      [CheckbotStatusEnum.error]: `@:checkBotStatus.${CheckbotStatusEnum.error}`,
      [CheckbotStatusEnum.timedOut]: `@:checkBotStatus.${CheckbotStatusEnum.timedOut}`,
      [CheckbotStatusEnum.warning]: `@:checkBotStatus.${CheckbotStatusEnum.warning}`,
      // For formal control filter select
      [MetadataCheckStatus.FAILED]: `@:metadataCheckStatus.${MetadataCheckStatus.FAILED}`,

      [InspectorStatusEnum.accepted]: `@:inspectorStatus.${InspectorStatusEnum.accepted}`,
      [InspectorStatusEnum.acceptedWithRemarks]: `@:inspectorStatus.${InspectorStatusEnum.acceptedWithRemarks}`,
      [InspectorStatusEnum.timedOut]: `@:inspectorStatus.${InspectorStatusEnum.timedOut}`,
      // [InspectorStatusEnum.waiting]: `@:inspectorStatus.${InspectorStatusEnum.waiting}`,
      [InspectorStatusEnum.rejected]: `@:inspectorStatus.${InspectorStatusEnum.rejected}`,
      [InspectorStatusEnum.waitingForFormalControl]: '-',

      undefined: '-',

      [RecordLibraryTransferStatus.SUCCESSFULL]: `@:recordLibraryTransferStatus.${RecordLibraryTransferStatus.SUCCESSFULL}`,
      // [RecordLibraryTransferStatus.FAILED]: `@:recordLibraryTransferStatus.${RecordLibraryTransferStatus.FAILED}`,

      recordLibraryTransferStatus: 'Transfer to Daisy',
    },

    // old
    projectDetails: 'Projekt Details',
    addSupplier: 'Add supplier',
    showCoworkers: 'Show coworkers',
    hideCoworkers: 'Hide coworkers',
    addCoworker: 'New coworker',
    docuManagers: 'Document managers',
    addDocuManager: 'Add document manager',
    generalInfo: 'General information',
    suppliers: 'Suppliers',
    configuration: 'Configuration',
    csvMapping: 'Column mapping',
    contentTypeMapping: 'Content type mapping',
    chooseContentType: 'Choose content type',
    noContentTypeSelected: 'No content type selected',
    contentTypeAlreadyAdded:
      'This content type was already added for this supplier',
    filesOverview: 'Files overview',
    fileUpload: 'File upload',
    action: 'Action',
    assignedContentTypes: 'Assigned content types',
    contentTypesManagement: 'Content types management',
  },

  adminPanel: {
    appConfiguration: 'App Konfiguration',
    checkBotTimeout: 'Checkbot Timeout (in days)',
    saveChanges: '@:generic.saveChanges',
    firstName: '@:generic.firstName',
    lastName: '@:generic.lastName',
    email: '@:generic.email',
    administration: '@:generic.administration',
    docuManager: '@:generic.docuManager',
    checkCheckBotResults: 'Check check bot results',
    checkMetadataInferenceResults: 'Check check bot metadata results',
    checkCheckBotTimeouts: 'Check check bot timeouts',
    errors: {
      errorCheckingCheckBotResults:
        'An error occured while checking check bot results.',
      errorCheckingCheckBotTimeouts:
        'An error occured while checking check bot timeouts',
    },
  },

  uploadsOverview: {
    deliveries: 'Deliveries',
    newDelivery: 'New delivery',
    errors: {
      couldNotLoadDeliveries: 'An error occured while loading deliveries',
    },
    supplier: 'Supplier',
    count: 'Doc.',
    contentType: 'Content type',
    content: 'Content',
    documentStatus: 'Document status',
    uploadDate: 'Upload date',
    inspectionDueDate: 'Inspection due date',
    soonest: 'soonest',

    supplierName: 'Supplier',
    filterContentTypes: 'Filter content types',
    new: 'New',
    updated: 'Updated',

    tooltips: {
      downloadUploadConfirmation: 'Download upload confirmation',
      updateUpload: 'Update upload',
      uploadCannotBeUpdated: 'This upload cannot be updated.',
      uploadConfirmationNotReady: 'Upload confirmation is not ready yet',
      removeUpload: 'Anlieferung entfernen',
      uploadCannotBeRemoved: 'This upload cannot be removed.',
    },

    checkbotConfig: 'Checkbot Config',
    hideProcessed: 'Hide completed uploads',
  },

  projectsSuppliers: {
    supplierName: 'Name',
    contentTypes: 'Content types',
    deliveries: 'Deliveries',
    suppliers: 'Suppliers',
    coworkers: 'Coworkers',
    assignedContentTypeNames: 'Content types',
    description:
      'Welcome to our supplier overview and management! ' +
      'Here you can bring together all information about ' +
      'your suppliers in one place.',
    addSupplier: 'Add supplier',
    errors: {
      couldNotLoadSuppliers:
        'An error occured while loading projects suppliers',
      couldNotUpdateConfigTemplate:
        'An error occured while updating the check bot configuration template',
      templateAlreadyAssigned:
        'The check bot configuration was already set for this supplier',
      couldNotLoadTestKeys:
        'An error occured while loading test keys for standard check bot configurations.',
      supplierAlreadyAdded: 'This supplier was already added to this project.',
      errorRemovingSupplier:
        'An error occured while removing this supplier from this project.',
      cannotRemoveSupplierWithUploads:
        'This supplier cannot be removed from this project because he already has made uploads.',
    },
    setCheckBotConfigTemplate: 'Set check bot configuration template',
    checkBotConfigTemplate: 'Check bot config. template',
    checkBotConfig: 'Check bot configuration',
    checkBotConfigTemplateSet:
      'Check bot configuration template was successfully set',
    checkBotConfigTemplateSetShort: 'Checkbot Konfiguration eingestellt',
    enterSupplierName: 'Enter supplier name',
    [CheckBotModuleStrings.CUSTOM_CHECK_BOT_CONFIG]: 'custom',
    tooltips: {
      editCheckBotConfig: 'Edit check bot config',
      applyCheckBotConfigTemplate: 'Apply check bot config template',
      editSupplier: 'Edit supplier',
    },
    templateReassignmentConfirmation:
      'This template was customized. Are you sure you want to overwrite it?',
    deactivated: 'Deactivated',
    supplierSuccessfullyDeleted:
      'The supplier was successfully removed from this project.',
  },

  projectsCoworkers: {
    errors: {
      couldNotLoadProjects:
        'An error occured while loading coworkers in project',
      couldNotRemoveCoworker:
        'An error occured while trying to remove the coworker from this project.',
    },
    firstName: 'First name',
    lastName: 'Last name',
    supplier: 'Supplier',
    email: 'Email',
    description:
      'Welcome to our employee overview and management! ' +
      'Here you can centrally manage and organize all ' +
      'information about supplier employees to ensure ' +
      'smooth project processes.',
    coworkers: 'Coworkers',
    addCoworker: 'Add coworker',
    coworkerRemoved: 'The coworker was successfully removed from the project.',
  },

  supplierDetailView: {
    coworkers: 'Coworkers',
    contentTypes: 'Content types',
    checkBot: 'Check bot',
    assignedConfiguration: 'Assigned configuration',
    configurationEditor: 'Configuration editor',
    assignConfiguration: 'Assign configuration',
    noConfigurationAssigned: 'No configuration was assigned',
    errors: {
      couldNotGetCoworkers: 'An error occured while loading supplier coworkers',
    },
  },

  pageTop: {
    languages: {
      en: 'English',
      de: 'German',
    },
    logout: 'Logout',
    currentUser: 'Current user',
    chooseLang: 'Choose language',
  },

  sidebar: {
    header: 'SP Documentation Portal',
    dashboard: 'Dashboard',
    suppliers: 'Supplier management',
    addSuplier: 'Add supplier',
    suppliersList: 'Suppliers list',
    projects: 'Projects',
    projectsList: 'Projects list',
    adminPanel: 'Admin panel',
  },

  suppliersForm: {
    addSupplier: 'Add supplier',
    name: 'Name',
    supplierId: 'SAP supplier ID',
    address: 'Address',
    street: 'Street',
    houseNumber: 'House number',
    ZIPCode: 'ZIP code',
    city: 'City',
    validationErrorEmpty: 'Field cannot be empty',
    validationErrorToLong: 'The maximum number of characters is 256',
    validationErrorZIPCode: 'The ZIP code must have exactly 5 digits',
    submit: 'Submit',
    supplierCreated: 'Supplier created',
    submittingSupplier: 'Supplier is being created',
    submitError: 'Sorry, an error occurred while processing your request',
    submittingChanges: 'Saving changes',
    changesSubmitted: 'Your changes have been saved',
  },

  supplierDetails: {
    tabs: {
      informations: 'Informations',
      projects: 'Projects',
      coworkers: 'Coworkers',
      contentTypes: 'Content types',
      deliveries: 'Deliveries',
      documents: 'Documents',
      authTokens: 'API tokens management',
    },

    informations: {
      informations: '@:supplierDetails.tabs.informations',
      street: 'Street',
      houseNumber: 'House number',
      ZIPCode: 'ZIP code',
      city: 'City',
      SAPNumber: 'SAP-No.',

      errors: {
        couldNotGetSupplierDetails: 'An error occured while loading supplier',
      },
    },

    coworkers: {
      coworkers: '@:generic.coworkers',
      firstName: '@:generic.firstName',
      lastName: '@:generic.lastName',
      email: '@:generic.email',
      description:
        'Welcome to our employee overview and administration! ' +
        'Here, you can centrally manage ' +
        'and organize all information about supplier employees ' +
        'to ensure smooth project workflows.',
      addCoworker: 'Add Coworker',
      errors: {
        couldNotAddCoworker: 'An error occured while adding coworker',
        coworkerAlreadyAddedLong:
          'Cannot assign this coworker to this supplier because he was already assigned to supplier {supplierName}',
        coworkerAlreadyAddedShort: 'Cannot assign coworker',
      },
    },

    // old
    supplierDetails: 'Supplier details',
    editSupplier: 'Edit supplier',
    chooseCoworker: 'Choose coworker',
    updateSupplier: 'Save',
    cancelUpdateSupplier: 'Cancel',
    coworkerAlreadyAdded: 'This coworker was already added.',
    coworkersList: 'Coworkers list',
    noCoworkerSelected: 'Coworker was not selected',
    coworkerAdded: 'Mitarbeiter wurde hinzugefügt',
    addCoworkerToSupplier: 'Add coworker to supplier',
    actions: 'Actions',
    deleteCoworker: 'Delete coworker',
    coworkerDeleted: 'Coworker was succesfully deleted',
  },

  projectSettings: {
    settings: 'Settings',
  },

  projectForm: {
    title: 'Title',
    number: 'Number',
    externalId: 'External ID',
    location: 'Location',
    status: 'Status',
    duration: 'Duration',
    inspectionDueTime: 'Inspection due time (in days)',
    description: 'Description',
    projectStatus: {
      [ProjectStatus.ACTIVE]: 'active',
    },
    changesSaved: 'Changes were successfuly saved',
    saveChanges: 'Save changes',
    cancel: 'Cancel',
    createDigitalizationProject: 'Create internal project',
    projectDataUpdated: 'Successfully updated project data.',
    errors: {
      externalIdNotUnique: 'A project with this external ID already exists.',
      wrongProjectNumber: 'Wrong project number',
      projectNumberNotUniqueForSite:
        'A project with this number already exists for this site.',
      bothDatesRequired: 'Both dates are required.',
      errorUpdatingProject: 'An error occured while updating the project data.',
    },

    projectTitle: 'Project title',
    projectNumber: 'Project number',
    projectLocation: 'Projekt location',
    projectDescription: 'Project description',
    assignedSuppliers: 'Assigned suppliers',
    assignedCoworkers: 'Assigned coworkers',
    KKS: 'KKS',
    projectDuration: 'Project duration',
    durationStart: 'Duration start',
    durationEnd: 'Duration end',
    submit: 'Create project',
    updateProject: 'Save',
    cancelUpdateProject: 'Cancel',
    submitError: 'Sorry, an error occurred while processing your request',
    submittingChanges: 'Saving changes',
    changesSubmitted: 'Your changes have been saved',
    projectCreated: 'Project created',
    submittingProject: 'Project is being created',
    durationStartLaterThanEnd:
      'The start date cannot be later than the end date',
    mandatoryFieldsInfo: 'Mandatory fields are marked with *',
    projectNumberWrongSignes:
      'Project number has to be alphanumeric (- and _ are allowed).',
    projectTitleWrongSignes:
      'Project title has to be alphanumeric (- and _ are allowed).',
  },

  projectsDocuManagers: {
    warnings: {
      unknownUser: 'Unknown users could not be resolved',
    },
    lastName: 'Last name',
    email: 'Email',
    docuManager: 'Document manager | Document managers',
    addDocuManager: 'Add docu manager',
    errors: {
      couldNotGetDocuManagers:
        'An error occured while loading projects docu managers',
      docuManagerAlreadyAdded:
        'This document manager was already added to this project.',
      cannotRemoveLast:
        'The last document manager cannot be removed from the project.',
      errorRemovingDocuManager:
        'An error occured while removing the document manager.',
      cannotRemoveSelf:
        'A document manager cannot remove themselves from the project.',
    },
  },

  inspectors: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    inspectors: 'Inspectors',
    addInspector: 'Add inspector',
    specialization: 'Specialization',
    inspectorAdded: 'inspector succesfully added',
    inspectorAlreadyAdded: 'This inspector was already added',
    couldNotGetInspectors: 'An error occured while loading inspectors',
    couldNotAddInspector:
      'An error occured while assigning coworker to this project',
    docuManagerAlreadyAdded:
      'This document manager was already assigned to this project.',
    errors: {
      errorRemovingInspector: 'An error occured while removing the inspector.',
      cannotRemoveLast: 'The last inspector cannot be removed from a project.',
    },
    warnings: {
      unknownUser: 'Unknown users could not be resolved',
    },
  },

  createProject: {
    errors: {
      noDocuManagersAdded: 'At least one document manager has to be assigned.',
      couldNotCreateProject: 'An error occured while creating this project',
    },
  },

  projectConfiguration: {
    inspectionTime: 'Inspection due time setting',
    days: 'days',
    inspectionTimeSet: 'Inspection time set',
  },

  coworkerDetailView: {
    coworkerDetails: 'Coworker details',
    projects: 'Projects',
    project: 'Project',
    supplier: 'Supplier',
    projectId: 'Project number',
    supplierId: 'Supplier ID',
  },

  addSupplierToProject: {
    addSupplierToProject: 'Add supplier to project',
    add: 'Add',
    actions: 'Actions',
    remove: 'Remove',
    supplierAdded: 'Supplier added',
    availableSuppliers: 'Available suppliers',
    assignedSuppliers: 'Assigned suppliers',
  },

  addCoworkerToProject: {
    addCoworkerToProject: 'Add coworker to project',
    coworkerAdded: 'Added coworker to project',
    errors: {
      couldNotGetSuppliersCoworkers:
        'An error occured while loading suppliers coworkers',
      couldNotGetProjectsCoworkers:
        'An error occured while loading suppliers added to this project',
      couldNotAddCoworker:
        'An error occured while adding coworker to this project',
      couldNotAddCoworkerToSupplier:
        'An error occured while adding coworker to supplier',
      coworkerAlreadyAddedLong:
        'Cannot assign this coworker to this supplier because he was already assigned to supplier {supplierName}',
      coworkerAlreadyAddedShort: 'Cannot assign coworker',
    },
  },

  addDocuManagerToProject: {
    addDocuManagerToProject: 'Add document manager to project',
    docuManagerAdded: 'Added document manager to project',
  },

  docuManagersTable: {
    addDocuManager: 'Assign document manager',
    deleteDocuManager: 'Delete document manager',
    errors: {
      couldNotGetDocuManagers:
        'An error occured while loading document managers',
    },
  },

  docuManagers: {
    docuManager: 'Document manager | Document managers',
  },

  docuManagerDetailView: {
    docuManagerDetails: 'Document manager details',
    exchangeDocuManager: 'Exchange document manager in all projects',
    selectNewDocuManager: 'Select new document manager',
    docuManagerExchanged: 'Document manager was successfully exchanged',
    noDocuManagerSelected: 'No document manager was selected',
  },

  contentTypeConfiguration: {
    contentTypeConfiguration: 'Import configuration',
    uploadCsv: 'Upload CSV sheet',
    identifiedColumns: 'Identified columns',
    csvColumns: 'CSV Columns',
    contentTypeField: 'Content type field',
    dataType: 'Data type',
    importField: 'Import value',
    importFieldType: 'Import-Wert-Typ',
    csvMapping: 'Column mapping',
    selectForAllFields: 'Select import fields for all mandatory fields',
    mappingSaved: 'Contenttype mapping saved',
    revision: 'Revision',
    relativePath: 'Relative path',
    checkBotField: 'Checkbot field',
    checkBotFieldsValidationError:
      'The following required check bot fields were not assigned to a content type field: {missingFields}',
    duplicateCheckBotFieldsAssignments:
      'Every check bot field can be assigned to only one content type field',
    checkBotFieldOnlyWithCSVField: 'Missing import value',
    constantValue: 'Constant value',
    currentDate: 'Current date',
    csvField: 'CSV field',
    presetValue: 'Preset value',
    errors: {
      couldNotGetPossibleTaxonomyValues: 'Could not get taxonomy values',
      errorGettingMapping:
        'An error occured while loading the import configuration.',
      errorSavingMapping:
        'An eror occured while saving the import configuration',
    },
  },

  documentUpload: {
    zipToolHint:
      'We recommend compressing ZIP files larger than 1.5GB using the 7-Zip tool with the deflate algorithm.',
    fileName: 'File name',
    importDataSets: 'Import metadata',
    uploadFiles: 'Upload files',
    uploadFile: 'Upload file',
    uploadFileSecondary: 'Upload file',
    dragFileHere: 'Drag & drop your file here',
    upToSize: 'Up to {size}',
    csvImport: 'CSV import',
    zipUpload: 'Zip upload',
    massUpload: 'Mass upload',
    singleUpload: 'Single upload',
    newUpload: 'New upload',
    documentUpload: 'Document upload',
    fileUpload: 'File upload',
    manualEntry: 'Manual entry',
    dataSets: 'Data sets',
    fileSetsAndFileUpload: 'File sets and file upload',
    documentId: 'Document-ID',
    upload: 'Upload',
    source: 'Source',
    documentStatus: 'Document status',
    filepath: 'Filepath',
    file: 'File',
    actions: 'Actions',
    header:
      'Document upload {uploadId} for {projectName} of content type {contentTypeName}',
    version: 'Version',
    id: 'ID',
    singleUploadInfo: 'Upload single file',
    massUploadInfo: 'Upload multiple files from an Zip archive',
    fileFound: 'File found',
    finalizeUpload: 'Finalize upload',
    metadataFor: 'Metadata for {fileName}',
    validationErrorEmpty: 'Field cannot be empty',
    fileMissing: 'File has to be added',
    filesUploaded: 'Files have been successfully uploaded to Sharepoint',
    noMappingAssigned:
      'No content type mapping was assigned for this content type by this supplier in this project. Please contact the document manager of this project.',
    referenceNumberError:
      'An upload with this reference number was already made in this project.',
    errorReadingCsv: 'An error occured while reading the CSV file',
    field: 'Field',
    value: 'Value',
    newValue: 'New value',
    oldValue: 'Old value',
    [UploadType.NEW_DOCUMENT]: 'New document',
    [UploadType.UPDATED_DOCUMENT]: 'Updated document',
    [UploadType.UPDATED_METADATA]: 'Updated metadata',
    singleUploadDescription: 'Upload one file according to the CSV schema.',
    mainFile: 'Main file',
    renditionFile: 'Rendition file',
    errors: {
      missingFile: 'File missing.',
      missingRequiredFields: 'All required fields have to bee filled out.',
      fileToBigShort: 'File is to big',
      fileToBig:
        'The file You are trying to upload is to big. The maximum size is {maxSize}.',
      uploadError: 'An error occured while uploading documents',
      noUploadRecords: 'The upload contains no records',
      uploadFailed: 'An error occured while uploading documents',
      wrongDateFormat:
        'The date should be in the following format: "DD.MM.YYYY".',
      invalidDocumentId:
        'The document ID must be alphanumeric (- and _ are allowed).',
      zipCorrupted: 'The uploaded ZIP file is corrupted.',
      forbiddenCharacters: 'The file name contains forbidden characters',
      validationError: 'An error occured while validating the upload.',
      cannotGetMetadataChanges:
        'An error occured while checking the metadata changes.',
      cannotCheckPreviousVersions:
        'An error occured while checking previous version of the documents.',
      mainFileMustBePdf: 'The main file must be a PDF file.',
      renditionFileMustNotBePdf: 'The rendition file must not be a PDF file.',
      toManyFilesForDocId:
        'For these document IDs more than one file was found in the CSV: {documentIds}',
      mainFileMissing:
        'For these document IDs the main file was not provided: {documentIds}',
      renditionRecordMissing:
        'For these document IDs the CSV does not contain an entry ' +
        'for the rendition file although the previous version of the ' +
        'document had a rendition: {documentIds}',
      singleUploadMainFileMissing: 'The main file is missing.',
      mainFileNoPdf:
        'Warning: The selected file has no associated PDF as the main file and will be uploaded as the sole main file.',
      singleUploadRenditionFileMissing:
        'The rendition file is missing although the previous version of ' +
        'the document had a rendition.',
      singleUploadMainFileDuplicate: 'The main file already exists in Daisy.',
      singleUploadRenditionFileDuplicate:
        'The rendition file already exists in Daisy.',
      noUploadableFiles:
        'No valid files to upload. All files may already exist in Daisy or no files have been provided.',
    },
    warnings: {
      noFilesFound: 'No matching files where found in the ZIP archive.',
      fileIsEmpty: 'The uploaded file is empty.',
    },
    uploadSuccessfull:
      'The file was succesfully uploaded.|The files were succesfully uploaded.',
    uploadSuccessfullShort: 'File uploaded|Files uploaded',
    uploadZipFile: 'Upload ZIP file',
    uploadDirectory: 'Upload directory',
    uploadMultipleFiles: 'Upload files',
    uploadPackage: 'Upload package',
    disabledCheckBotInspection: 'Disabled check bot inspection',
    noMetadataUpload: 'No-metadata upload',
    columnsWithMissingContent:
      'The following CSV columns are missing values for required fields:',
    fileDuplicateDetected: 'File duplicate detected in Daisy',
    renditionDuplicateDetected: 'Rendition file duplicate detected in Daisy',
    openInDaisy: 'Open Document in Daisy',
  },

  ADModal: {
    noUserSelected: 'User was not selected',
    pressEnterToSelect: 'Press enter to select',
    pressEnterToRemove: 'Press enter to remove',
    enterAtLeast3Characters: 'Enter at least 3 characters',
    noData: 'No data',
  },

  spGroupModal: {
    noUserSelected: 'User was not selected',
    pressEnterToSelect: 'Press enter to select',
    pressEnterToRemove: 'Press enter to remove',
    noData: 'No data',
    couldNotGetUsers: 'An error occured while loading Active Directory users',
    noResults: 'No results',
    selectUser: 'Select user',
  },

  adGroupModal: {
    noUserSelected: 'User was not selected',
    pressEnterToSelect: 'Press enter to select',
    pressEnterToRemove: 'Press enter to remove',
    noData: 'No data',
    couldNotGetUsers: 'An error occured while loading ad users',
    noResults: 'No results',
    selectUser: 'Select user',
  },

  filesOverview: {
    newUpload: 'New upload',
    uploadId: 'Reference no.',
    selectContentType: 'Content type',
    provideUploadId: 'Reference number has to be provided',
    provideContentType: 'Content type has to be selected',
    provideSupplier: 'Supplier has to be selected',
    id: 'ID',
    uploadedIn: 'Upload ID',
    contentType: 'Content type',
    inspectionDueDate: 'Inspection due date',
    fileStatus: 'Formal Control',
    uploadDate: 'Upload date',
    inspectorStatus: 'Inspector status',
    supplier: 'Supplier',
    coworker: 'Coworker',
    actions: 'Actions',
    all: 'All',
    select: 'Select',
    acceptSelected: 'Accept selected',
    rejectSelected: 'Reject selected',
    confirmStatusChanges: 'Confirm status changes',
    followingDocumentsWillBeAccepted: 'Following documents will be accepted:',
    followingDocumentsWillBeRejected: 'Following documents will be rejected:',
    showAfterCheckbot: 'Show only files checked by Checkbot',
    plusOthers: '+ others',
    changeInspectionDueDate: 'Change inspection due date',
    newInspectionDueDate: 'New inspection due date',
    inspectorStatusChangeSuccessfullFiles:
      'The inspector status was successfully changed for {successfullCount} document. | The inspector status was successfully changed for {successfullCount} documents.',
    inspectorStatusChangeFailedFiles:
      'An error occured while changing the inspector status of {failedCount} document. | An error occured while changing the inspector status of {failedCount} documents.',
    errors: {
      inspectionDueDateChangeError:
        'An error occured while changing the inspection due dates',
    },
    checkBotConfiguration: 'Check bot configuration',
    provideCheckBotConfig: 'Check bot configuration must be selected',
  },

  missingFilesModal: {
    title: 'Missing files',
    missingFiles: 'Some files are missing and will not be uploaded',
    cancel: 'Cancel',
    submit: 'Submit',
    missingFilesWithChangedMetadata:
      'For these file IDs only their metadata will be updated, because the files are not appended',
    emptyFiles: 'Empty files (0 Bytes) were uploaded for these file IDs',
  },

  documentDetailView: {
    document: '@:generic.document',
    updateDocument: 'Update document',
    updateDocumentTitle: 'Update document',
    updateDocumentWithRenditionHint:
      'This document already has a rendition. Updating requires both files.',
    updateDocumentWithoutRenditionHint:
      'This document has no rendition. Only the main file can be updated.',
    updateDocumentSuccessful: 'The document file was updated successfully.',
    remarksPlaceHolder: 'Conditions under which the document is accepted.',
    documentDetails: 'Document details',
    metadata: 'Metadata',
    checkBotStatus: 'Formal control',
    inspectorStatus: 'Inspector status',
    openFile: 'Open file',
    downloadDocument: 'Download file',
    downloadRenditionFile: 'Download rendition file',
    accept: 'Accept',
    acceptWithRemarks: 'Accept document w. rem.',
    reject: 'Reject',
    remarks: 'Remarks',
    inspectorStatusChanged: 'Inspector status was changed',
    checkBotDetails: 'Checkbot details',
    rerunFormalControl: 'Rerun formal control',
    successfullyRerunFormalControl: {
      short: 'Formal control rerun',
      long: 'The formal control was rerurn.',
    },
    checkBotEstablishedKksNumbers: 'KKS proposals',
    copyCheckBotKks: 'Copy all',
    copyValidatedKks: 'Copy confirmed',
    checkBotEstablishedKksCopied: {
      short: 'KKS copied',
      long: 'The check bot KKS was successfully copied. | The check bot KKS were successfully copied.',
    },
    metadataCheckAccepted: 'The metadata check was succesfully accepted.',
    tabs: {
      document: 'Document',
      history: 'Document history',
    },
    errors: {
      cannotDownloadFile: 'An error occured while downloading the file.',
      cannotLoadUpdateInfo:
        'An error occured while loading the document update info.',
      cannotUpdateDocument:
        'An error occured while updating the document file.',
      mainFileRequired: 'The main file is required.',
      renditionFileRequired:
        'The rendition file is required for this document.',
      cannotRemoveLastValue: {
        short: 'Cannot remove this value',
        long: 'The last value of a mandatory field cannot be removed.',
      },
      cannotGetPossibleValues: {
        short: '@:errors.error',
        long: 'An error occured while getting the possible metadata values.',
      },
      errorRerunningMetadataCheck: {
        long: 'An error occured while executing the metadata check.',
      },
      errorCopyingEstablishedKks: {
        long: 'An error occured while copying the established KKS',
      },
      errorValidatingMetadata: 'Metadata validation failed.',
      errorAcceptingMetadataCheck:
        'An error occured while accepting the metadata check.',
    },
    history: {
      errors: {
        errorGettingHistory: 'An error occured while loading documents history',
      },
      event: 'Event',
      date: 'Date',
      actor: 'Actor',
      statusChange: 'Status change',
      note: 'Note',
      additionalInfo: 'Additional information',
      events: {
        [DocumentEvent.UPLOAD]: 'Upload performed',
        [DocumentEvent.FAILED_UPLOAD]: 'Failed upload',
        [DocumentEvent.INSPECTION]: 'Content inspection',
        [DocumentEvent.QUALITY_CHECK]: 'Quality check completed',
        [DocumentEvent.CHECKBOT_RESULT]:
          'Formal check for content accuracy completed',
        [DocumentEvent.COPIED_TO_RECORD_LIBRARY]: 'Daisy transfer',
        [DocumentEvent.RENDITION_FILE_COPIED_TO_RECORD_LIBRARY]:
          'Rendition file Daisy transfer',
        [DocumentEvent.CHECKBOT_INPUT_LIST_ENTRY]:
          'Formal check for content requested',
        [DocumentEvent.CHECKBOT_INPUT_FAILED]:
          'Failed to create check bot entry',
        [DocumentEvent.METADATA_CHECK_RESULT]:
          'Formal check for taxonomic accuracy completed',
        [DocumentEvent.REVERTED_TO_METADATA_CHECK]:
          'Document was reverted to metadata check due to a change in the metadata.',
        [DocumentEvent.FAILED_CHECK_SUPPLIER_NOTIFICATION]:
          'Notification to the supplier about failed formal check',
        [DocumentEvent.NEW_RESULTS_INSPECTOR_NOTIFICATION]:
          'Notification to inspectors about formal check results',
        [DocumentEvent.INSPECTION_DUE_INSPECTORS_NOTIFICATION]:
          'Notification to inspectors about pending inspection deadline',
        [DocumentEvent.FAILED_INSPECTION_SUPPLIER_NOTIFICATION]:
          'Notification to the supplier about failed content inspection',
        [DocumentEvent.METADATA_INFERENCE_CHECKBOT_INPUT_LIST_ENTRY]:
          'AI suggestions requested',
        [DocumentEvent.METADATA_INFERENCE_CHECKBOT_RESULT]:
          'AI suggestions received',
        [DocumentEvent.DOCUMENT_UPDATED]: 'Document updated',
        [DocumentEvent.DUPLICATE_DETECTED]: 'Duplicate detected',
      },
      [ACTOR_APP]: 'Application',
      failureReason: 'Failure reason',
      failureReasons: {
        [FailureReason.FIREWALL_EXCEPTION]:
          'The request was blocked by the firewall.',
      },
    },
    inspectionDueDate: 'Inspection due date',
    changeInspectionDueDate: 'Change inspection due date',
    inspectionDueDateChanged: 'Inspection due date changed succesfully',
    continueProcess: 'Continue process',
    showKksProposals: 'Show KKS proposals',
    hideKksProposals: 'Hide KKS proposals',
    kksProposalsModalTitle: 'KKS Proposals',
    kksInBigModalTitle: 'Show KKS in BIG',
    showKksInBig: 'Show KKS in BIG',
    acceptKksProposal: 'Accept',
    bigModalSapPmHint: 'Only KKS with status SAP-PM can be displayed in BIG.',
    filepathInfo:
      'This field shows the file path within a delivered ZIP archive. If the document was placed in a subfolder inside the ZIP, the full path is shown here – e.g. "subfolder/document.pdf". If only the filename appears without any path, the file was located directly in the root of the ZIP with no subfolders.',
    showAllMetadata: 'Show all metadata',
    showLessMetadata: 'Show less metadata',
    openInNewTab: 'Open document in a new tab',
    kksTree: 'KKS-tree',
    workspace: {
      info: 'The Document ID is the ID of the working copy. The Original Document ID is the actual ID of the document in Daisy. While editing, the original document is locked in Daisy; after successful approval, the working copy replaces the Daisy document.',
    },
  },

  remarksModal: {
    title: {
      [RemarksModalMode.ACCEPT_WITH_REMARKS]: 'Accept document with remarks',
      [RemarksModalMode.REJECT]: 'Reject document',
    },
    remarksPlaceHolder: {
      [RemarksModalMode.ACCEPT_WITH_REMARKS]: 'Remarks about the document',
      [RemarksModalMode.REJECT]: 'Reasons of rejection',
    },
    errors: {
      enterRemarks: {
        [RemarksModalMode.ACCEPT_WITH_REMARKS]: 'Provide remarks',
        [RemarksModalMode.REJECT]: 'Provide reasons of rejection',
      },
    },
  },

  checkBotConfigurator: {
    checkBotConfiguration: 'Check bot Configuration',
    checkBotConfigurationSavedShort: 'Check bot configuration saved',
    checkBotConfigurationSaved:
      'The check bot configuration was successfully saved.',
    errors: {
      couldNotGetCheckBotConfig:
        'An error occured while loading check bot configuration.',
      couldNotSaveCheckBotConfig:
        'An error occured while saving the check bot configuration.',
    },
    warnings: {
      checkWasAlreadyAdded: 'This check is already added.',
      checkWasAlreadyAddedShort: 'Check already added',
    },
  },

  addCheckModal: {
    addCheck: 'Add check',
    errors: {
      errorLoadingChecks: 'An error occured while loading check bot checks.',
    },
  },

  appConfig: {
    appConfig: 'App configuration',
    checkBotTimeout: 'Checkbot timeout',
    save: 'Save',
    days: 'days',
    checkBotTimeoutSaved: 'Checkbot timeout saved!',
  },

  checkBotResultsTable: {
    check: 'Check',
    state: 'Status',
    details: 'Details',
    result: 'Result',
    detailsCopied: 'Details copied',
    config: 'Configuration',
  },

  metadataCheckResultsTable: {
    metadataCheck: 'Metadata check',
    field: 'Field',
    value: 'Value',
    accepted: 'Status',
    errorMessage: 'Error',
    statuses: {
      true: 'Accepted',
      false: 'Rejected',
    },
  },

  progressStepsIndicator: {
    documentUploadFailed:
      'The upload of the document failed. Please contact the documentation manager of Your project.',
    timedOut: 'Timeout',
    [ProjectType.SUPPLIER_PROJECT]: {
      [DocuProcessingStep.UPLOAD]: 'Document uploaded',
      [DocuProcessingStep.FORMAL_INSPECTION]: 'Formal control',
      [DocuProcessingStep.CONTENT_INSPECTION]: 'Content control',
      [DocuProcessingStep.RECORD_LIBRARY_TRANSFER]: 'Transfer to Daisy',
    },
    [ProjectType.DIGITALIZATION_PROJECT]: {
      [DigiDocuProcessingStep.UPLOAD_DONE]: 'Document uploaded',
      [DigiDocuProcessingStep.METADATA_INSPECTION]: 'Metadata inspection',
      [DigiDocuProcessingStep.FORMAL_CONTROL]: 'Formal control',
      [DigiDocuProcessingStep.QUALITY_CHECK]: '@:generic.qualityCheck',
      [DigiDocuProcessingStep.RECORD_LIBRARY_TRANSFER]: 'Transfer to Daisy',
    },
  },

  footer: {
    privacy: 'Privacy',
    legalNotice: 'Legal notice',
  },

  styledTagsInput: {
    addTag: 'Add value',
  },

  forbiddenView: {
    heading: "You don't have access",
    subheading:
      "You don't have access. Contact Your document manager for the project.",
  },

  csvParsingErrorsModal: {
    csvErrors: 'The following errors occured while reading the CSV file:',
    error: 'Error',
    row: 'Row',
    InvalidQuotes: 'Trailing quote on quoted field is malformed',
    MissingQuotes: 'Quoted field unterminated',
    TooFewFields:
      'Too few fields: expected {expectedFieldsNumber} fields but parsed {parsedFieldsNumber}',
    TooManyFields:
      'Too many fields: expected {expectedFieldsNumber} fields but parsed {parsedFieldsNumber}',
    UndetectableDelimiter: 'Unable to auto-detect delimiting character',
  },

  fileNameErrorsModal: {
    forbiddenCharactersPresent:
      'There are forbidden characters in the file names.',
    documentId: 'Document ID',
    forbiddenCharacters: 'Forbidden characters',
  },

  digitalizationProjectsList: {
    addDigitalizationProject: 'Add internal project',
    description:
      'Welcome to our overview and management for internal projects! Here ' +
      'you can centrally manage and organize all information and progress ' +
      'related to your internal projects to ensure efficient and successful ' +
      'project implementation.',
    digitalizationProjects: 'Internal projects',
    errors: {
      errorGettingDigitalizationProjects: {
        long: 'An error occured while loading internal projects.',
      },
    },
    number: 'Number',
    status: 'Status',
    statuses: {
      [DigitalizationProjectStatus.ACTIVE]: 'active',
    },
    title: 'Title',
  },

  createDigitalizationProject: {
    addDigitalizationProject: 'Add internal project',
    errors: {
      digitalizationProjectNumberNotUnique: {
        long: 'An internal project with this project number already exists.',
      },
      errorCreatingDigitalizationProject: {
        long: 'An error occured while creating the internal project.',
      },
      noDocuResponsibleAdded: {
        long: 'At least one documentation responsible has to be added.',
      },
    },
    projectCreated: 'The internal project was successfully created.',
    requiredFieldsMarkedWith: 'Mandatory fields are marked with *.',
  },

  docuResponsiblesTable: {
    docuResponsibles: 'Documentation responsible | Documentation responsibles',
    errors: {
      couldNotGetDocuResponsibles: {
        long: 'An error occured while loading the docu responsibles.',
      },
    },
  },

  digitalizationProjectDetails: {
    errors: {
      errorLoadingProjectData:
        'An error occured while loading the project data.',
    },
    goToProjectRoom: 'Go to project room',
    tabs: {
      documents: 'Documents',
      ibl: 'IBL',
      informations: 'Informations',
      settings: 'Settings',
      suppliers: 'Suppliers',
      uploads: 'Uploads',
    },
  },

  digitalizationProjectContentTypes: {
    addContentType: 'Add content type',
    contentTypes: 'Content types',
    errors: {
      errorGettingContentTypes: {
        long: 'An error occured while loading the content types.',
      },
    },
    tableFields: {
      contentTypeName: 'Name',
      uploadsCount: 'Uploads',
    },
  },

  digitalizationUploadsOverview: {
    contentTypeName: '@:generic.contentType',
    documentsCount: 'Doc.',
    documentsStatuses: 'Documents statuses',
    errors: {
      errorGettingUploads: {
        long: 'An error occured while loading document uploads.',
      },
      errorRemovingUpload:
        'An error occured while removing the document upload.',
      errorRestoringUpload:
        'An error occured while restoring the document upload.',
      errorSoftDeletingUpload:
        'An error occured while marking the upload as faulty.',
    },
    hideProcessed: 'Hide completed uploads',
    showSoftDeleted: 'Show faulty uploads',
    newAndUpdatedDocumentsCount: 'Content',
    newUpload: 'New upload',
    referenceNumber: 'Reference no.',
    tooltips: {
      downloadUploadConfirmation: 'Download upload confirmation',
      uploadConfirmationNotReady: 'Upload confirmation is not ready yet',
      removeUpload: 'Anlieferung entfernen',
      softDeleteUpload: 'Mark upload as faulty',
      restoreSoftDeletedUpload: 'Restore faulty upload',
      uploadCannotBeRemoved: 'This upload cannot be removed.',
    },
    checkbotConfig: 'Checkbot Config',
    uploadDate: 'Upload date',
    uploadRemoved: 'Die Anlieferung wurde erfolgreich entfernt.',
    uploads: 'Uploads',
    uploadSoftDeleted: 'The upload was marked as faulty.',
    uploadRestored: 'The upload was successfully restored.',
  },

  qualityCheckPanel: {
    accept: 'Accept',
    errors: {
      errorSettingQualityCheckStatus: {
        long: 'An error occured while changing the quality check status.',
      },
    },
    qualityCheck: '@:generic.qualityCheck',
    qualityCheckStatusSet: 'The quality check status was changed successfully.',
    reject: 'Reject',
  },

  digitalizationDocumentsOverview: {
    queueCount: 'Documents in queue',
    checkBotInferenceStatus: 'AI Proposals',
    checkBotStatus: 'AI Formal Status',
    contentTypeName: '@:generic.contentType',
    continueProcess: 'Continue process',
    coworker: '@:generic.coworker',
    deselectAll: 'Deselect all documents',
    documentId: '@:generic.documentIdAbbreviated',
    documents: 'Documents',
    documentStatus: 'Process status',
    errors: {
      errorGettingDocuments: {
        long: 'An error occured while loading the documents.',
      },
    },
    formalControlStatus: '@:generic.inspection',
    plusOthers: '+ other',
    recordLibraryTransferStatus: '@:generic.recordLibraryTransfer',
    referenceNumber: 'Reference no.',
    revision: 'Rev.',
    selectAll: 'Select all documents',
    title: 'Title',
    qualityCheckStatus: '@:generic.qualityCheck',
    uploadDate: '@:generic.uploadDate',
  },

  digitalizationProjectInformations: {
    informations: 'Informations',
  },

  digitalizationProjectDocuResponsibles: {
    warnings: {
      unknownUser: 'Unknown users could not be resolved',
    },
    addDocuResponsible: 'Add docu responsible',
    cannotRemoveLastDocuResponsible:
      'The last docu responsible cannot be removed from the project.',
    docuResponsible: '@:roles.docuResponsible',
    docuResponsibleAdded: 'Docu responsible was successfully added.',
    docuResponsibleRemoved: 'Docu responsible was successfully removed.',
    email: '@:generic.email',
    errors: {
      docuResponsibleAlreadyAdded: {
        long: 'This docu responsible was already added to this project.',
      },
      errorAddingDocuResponsible: {
        long: 'An error occured while adding the docu responsible.',
      },
      errorGettingDocuResponsbiles: {
        long: 'An error occured while loading docu responsibles.',
      },
      errorRemovingDocuResponsible:
        'An error occured while removing the docu responsible.',
    },
    firstName: '@:generic.firstName',
    lastName: '@:generic.lastName',
  },

  metadataGridEditor: {
    changedHint: '✘ - Document will be moved back to formal control.',
    checkBotEstablishedKksNumbers: 'KKS proposals',
    dccProposals: 'DCC proposals',
    dccAiPrediction: 'DCC proposals (AI)',
    copyCheckBotKks: 'Copy all KKS',
    copyValidatedKks: 'Copy confirmed KKS',
    cancel: '@:generic.cancel',
    docAfterInferenceHint:
      'Documents with purple-marked ID were processed by the check bot.',
    inferredValueHint:
      'Brown-marked cells contain values that were inferred by the check bot.',
    errors: {
      errorGettingMetadata: 'An error occured while getting the metadata.',
      errorSavingMetadataChanges: 'An error occured while saving the metadata.',
      errorUpdatingQualityCheck:
        'An error occurred while changing the status of the quality check.',
      errorValidatingMetadata: 'Metadata validation failed.',
      errorGettingInferenceStatuses:
        'An error occured while getting the metadata inference statuses.',
    },
    hint: 'Hint',
    metadataEditor: 'Metadata editor',
    metadataSaved: 'The metadata was saved successfully.',
    notChangedHint: '✔ - The document is ready for transfer to Daisy',
    saveChanges: '@:generic.saveChanges',
    saveChangesAndContinue: 'Continue process',
    undoAcceptingKks: 'Undo KKS acceptance',
  },

  newDigitalizationUploadModal: {
    disableCheckBotInspection: 'Skip check bot inspection',
    noMetadataUpload: 'No-metadata upload',
    noMappingAssigned:
      'No content type mapping was assigned for this content type by this supplier in this project. Please contact the document responsible of this project.',
  },

  kksValidator: {
    errors: {
      errorValidatingKks: 'An error occured while validating the KKS values.',
    },
  },

  contentTypeFields: {
    ConfidentialClass: 'Vertraulichkeitsstufe',
    CreateDate: 'Create date',
    CreatedBy: 'Created by',
    CreatorDocumentNumber: 'Document number',
    // NOTE: Typo in dev, test, prod SharePoint
    CreaterDocumentNumber: 'Dokumentennummer',
    DDP_Projekt: 'Project',
    DocLanguage: 'Language',
    DocStatus: 'Status',
    DocumentClass: 'Master DCC',
    DocumentClassContent: 'Content DCC',
    DocumentCreator: 'Creator',
    documentId: 'Document-ID',
    originalDocumentId: 'Original-Document-ID',
    FolderNumber: 'Folder number',
    KKS: 'KKS',
    ObjectID: 'Object ID',
    OriginalFilename: 'Original filename',
    /** Typo in content type field on Queportdev SharePoint */
    OriginalFIlename: 'Original filename',
    Revision: 'Revision',
    RevisionNumber: 'Revision',
    Title: 'Title',
    ReleaseDate: 'Release date',
    ResponsibleArea: 'Responsible area',
    StationNumber: 'Station number',
    Filepath: 'Filepath',
    Asset: 'Asset',
    SubAsset: 'SubAsset',
  },

  kksPicker: {
    allowWildcardSelector: 'Include subnodes',
    copyToClipboard: 'Copy to clipboard',
    noSelectOptions: 'No entries available',
    searchPrompt: 'Please enter a search term...',
    selectStates: 'Please select at least one status',
    status: 'State',
    errors: {
      errorGettingKks: 'An error occured while loading the KKS codes.',
      unauthorizedKks: 'This KKS is outside of your authorization scope.',
    },
    addValue: 'Wert hinzufügen',
  },

  metadataValidationModal: {
    invalidDocumentIds: 'The following document IDs are invalid:',
    validationExplanation:
      'The document IDs must not contain special characters or spaces (- and _ are allowed).',
  },

  patchNotesEditor: {
    content: 'Content',
    continueEditing: 'Continue editing',
    createPatchNote: 'Create patch note',
    currentVersion: 'Current version',
    editExisingPatchNote: 'Edit existing patch note',
    editExistingVersion: 'Edit existing version',
    errors: {
      errorGettingCurrentAppVersion:
        'An error occured while getting the current app version.',
      errorSaving: 'An error occured while saving the patch note.',
      errorGettingPatchNote:
        'An error occured while loading the patch note content.',
      errorGettingPatchNoteVersions:
        'An error occured while loading the patch note versions.',
      releaseDatesConflict:
        'The release date cannot be earlier than the release date of the previous version of the application, i.e., {conflictingDate}.',
    },
    existingVersionHint:
      'The patch note version {version} already exists. Would you like to edit this version (the entered content will be replaced with the existing version) or continue working with the existing content?',
    modalTitle: 'Changes',
    patchNoteForCurrentVersionMissing:
      'Patch notes for the current version are missing.',
    patchNoteSuccessfullySaved: 'The patch note was saved successfully.',
    releaseDate: 'Release date',
    saveChangesForVersion: 'Save changes for version {version}',
    selectedVersion: 'Selected version',
    selectVersion: 'Select version',
    unsavedChangesHint: 'Unsaved changes will be lost.',
    version: 'Version',
  },

  datePicker: {
    enterDate: 'Enter date',
  },

  documentProcessingStatus: {
    [SupplierDocumentStatus.FORMAL_CONTROL]: 'Formal control',
    [SupplierDocumentStatus.FORMAL_CONTROL_FAILED]: 'Formal control failed',
    [SupplierDocumentStatus.CONTENT_CONTROL]: 'Content control',
    [SupplierDocumentStatus.CONTENT_CONTROL_FAILED]: 'Content control failed',
    [SupplierDocumentStatus.TIMED_OUT]: 'Timed out',
    [SupplierDocumentStatus.RECORD_LIBRARY_TRANSFER]: 'Transfer to Daisy',
    [SupplierDocumentStatus.RECORD_LIBRARY_TRANSFER_FAILED]:
      'Transfer to Daisy failed',
    [SupplierDocumentStatus.COMPLETED]: 'Completed',
  },

  iblView: {
    title: 'IBL',
    uploadList: 'Upload list',
  },

  iblUploadModal: {
    errors: {
      errorUploadingIbl: 'An error occured while uploading the IBL.',
      maxKksCountExceeded:
        'The maximum number of {maxKksCount} KKS has been exceeded.',
      wrongIblFormat: 'Wrong IBL format',
    },
    iblFile: 'IBL Datei',
    maxKksCount:
      'You can upload up to {maxKksCount} KKS entries in a single import.',
    noSupplierSelected: 'Supplier was not selected',
    successfullyUploadedIbl: 'The IBL was successfully uploaded.',
    supplier: 'Supplier',
    title: 'IBL upload',
  },

  iblImportResult: {
    errorTypes: {
      [IblImportErrorType.CONFLICT]:
        'For KKS {kks}, a value with a higher quality score already exists for the characteristic {vgbm}.',
      [IblImportErrorType.INTERNAL_ERROR]: 'Internal error',
    },
    missingResourceErrors: {
      [MissingResourceType.VGBK]: 'Class does not exist',
      [MissingResourceType.VGBM]: 'VGBM not available',
    },
    noIblsCouldBeImported: 'No IBLs could be imported',
    warningTypes: {
      [IblImportWarningType.INVALID_KKS]: 'Invalid KKS',
      [IblImportWarningType.INVALID_UNIT]: 'Invalid unit: {invalidUnit}',
      [IblImportWarningType.INVALID_VALUE]: 'Invalid value: {invalidValue}',
      [IblImportWarningType.UNKNOWN_WARNING]: 'Unknown warning',
    },
    forKks: 'For KKS {kks}:',
    someIblsCouldNotBeImported: 'Some IBLs could not be imported',
    warnings: 'Warnings',
  },

  projectSuppliersSelect: {
    errors: {
      errorGettingSuppliers:
        'An error occured while loading the suppliers for this project.',
    },
    selectSupplier: 'Select supplier',
  },

  vgbkSelect: {
    errors: {
      errorGettingVgbk: 'An error occured while loading the VGBK values.',
    },
    selectVgbk: 'Select VGBK',
  },

  vgbmTable: {
    errors: {
      errorGettingVgbm: 'An error occured while loading the VGBM values.',
    },
    vgbk: 'Class',
  },

  kksVgbmModal: {
    assignmentUpdated: 'VGBM assignment updated successfully.',
    errors: {
      errorGettingAssignments:
        'An error occured while loading the VGBM assignments.',
      errorSavingAssignment:
        'An error occured while saving the VGBM assignment.',
    },
    warnings: {
      invalidUnit: 'The entered unit "{unit}" is not VGB-compliant.',
      invalidValue: 'The entered value "{value}" is not VGB-compliant.',
    },
  },

  kksVgbmForm: {
    class: 'VGBM',
    description: 'Name',
    errors: {
      couldNotGetKks: 'An error occured while loading the KKS.',
      invalidLocation: 'The location does not exist.',
      kksDoesNotExist:
        'The KKS {kks} for location {location} does not exist in the system.',
    },
    hideEmpty: 'Hide empty rows',
    quality: 'Quality',
    qualityOptions: {
      [VgbmAssignmentQuality.UNKNOWN]: 'Unknown',
      [VgbmAssignmentQuality.NON_COMPLIANT]: 'Non-VGB-compliant',
      [VgbmAssignmentQuality.SUPPLIER_PROVIDED_NOT_CHECKED]:
        'Supplier provided, not verified',
      [VgbmAssignmentQuality.SUPPLIER_PROVIDED]: 'Supplier provided',
      [VgbmAssignmentQuality.MANUAL_ENTRY]: 'Manual entry',
    },
    qualitySelectPlaceholder: 'Quality',
    unit: 'Unit',
    value: 'Value',
  },

  checkBotConfigsManagement: {
    addConfiguration: 'Add configuration',
    checkBot: 'Check bot',
  },

  checkBotConfigsTable: {
    checksCount: 'Checks count',
    description: 'Description',
    errors: {
      errorGettingCheckBotConfigs:
        'An error occured while loading the check bot configurations.',
    },
    name: 'Name',
  },

  addCheckBotConfigModal: {
    configTemplate: 'Configuration template',
    newCheckbotConfig: 'New check bot configuration',
    templateOrStartEmpty:
      'A template has to be selected or "@:addCheckBotConfigModal.startEmpty" has to be selected',
    errors: {
      errorGettingTemplates:
        'An error occured while loading the configuration templates.',
    },
    startEmpty: 'Create empty configuration',
  },

  checkBotConfigurationView: {
    configDescription: 'Configuration description',
    configName: 'Configuration name',
    configSaved: 'The configuration was saved successfully.',
    createConfiguration: 'Create configuration',
    errors: {
      duplicateNameError:
        'A configuration with this name already exists. Please choose a different name.',
      errorGettingCheckBotConfig:
        'An error occured while loading the check bot configuration.',
      errorGettingCheckSchemas:
        'An error occured while loading the check bot schemas.',
      errorSavingConfig: 'An error occured while saving the configuration.',
    },
    saveConfiguration: 'Save configuration',
  },

  checkBotConfiguratorHeader: {
    checkBotConfiguration: 'Check bot configuration',
    errors: {
      errorGettingSupplierInfo:
        'An error occured while loading the supplier information.',
    },
  },

  checkConfiguration: {
    resultsConfig: 'Results',
  },

  checkPropertyEditor: {
    invalidFeedback: {
      [CheckPropertyValidationErrorType.MISSING_REQUIRED]:
        'Required field is missing',
      [CheckPropertyValidationErrorType.TOO_HIGH]:
        'Value must be less than or equal to {max}',
      [CheckPropertyValidationErrorType.TOO_HIGH_EXCLUSIVE]:
        'Value must be less than {max}',
      [CheckPropertyValidationErrorType.TOO_LOW]:
        'Value must be greater than or equal to {min}',
      [CheckPropertyValidationErrorType.TOO_LOW_EXCLUSIVE]:
        'Value must be greater than {min}',
      [CheckPropertyValidationErrorType.IS_NOT_INTEGER]:
        'Value must be an integer',
      [CheckPropertyValidationErrorType.TOO_MANY_ITEMS]:
        'There must be less than or equal to {max} items',
      [CheckPropertyValidationErrorType.TOO_FEW_ITEMS]:
        'There must be more than or equal to {min} items',
    },
  },

  checkResultsEditor: {
    invalidFeedback: {
      messageMissing: 'Required field is missing',
    },
  },

  addCheckSelect: {
    addCheck: 'Add check',
  },

  multiselect: {
    deselect: 'Press enter to remove',
    selected: 'Selected',
  },

  checkBotConfigSelect: {
    errors: {
      errorGettingCheckBotConfigs:
        'An error occured while loading the check bot configurations.',
    },
    selectConfig: 'Select check bot configuration',
  },

  validations: {
    invalid_type: 'The field must be of type { expected }.',
    invalid_literal: 'Invalid input: { expected } is expected.',
    invalid_union: 'Invalid input',
    invalid_union_discriminator: 'Invalid input',
    invalid_enum_value: 'Invalid input: one of { options } is expected.',
    unrecognized_keys: 'Unrecognized fields { keys }.',
    invalid_date: 'Invalid date',
    invalid_string: 'Invalid input',
    too_small: {
      array: 'The list must contain at least { minimum } entries.',
      string: 'The field must contain at least { minimum } characters.',
      number: 'The field value must be at least { minimum }.',
      set: 'The list must contain at least { minimum } entries.',
      date: 'The date must be after { minimum }.',
      bigint: 'The field value must be at least { minimum }.',
    },
    too_big: {
      array: 'The list may contain at most { maximum } entries.',
      string: 'The field may contain at most { maximum } characters.',
      number: 'The field value may be at most { maximum }.',
      set: 'The list may contain at most { maximum } entries.',
      date: 'The date must be before { maximum }.',
      bigint: 'The field value may be at most { maximum }.',
    },
    invalid_intersection_types: 'Invalid input',
    not_multiple_of: 'The field value must be divisible by { multipleOf }.',
    not_finite: 'The field value must be finite.',
    types: {
      array: 'List',
      string: 'Text',
      number: 'Number',
      set: 'List',
      date: 'Date',
      bigint: 'Number',
    },
  },

  filters: {
    equals: 'Equals',
    contains: 'Contains',
    startsWith: 'Starts with',
    endsWith: 'Ends with',
  },

  iframeLoginView: {
    logIn: 'Log in',
  },
  oauthCloseView: {
    title: 'Login complete',
    hint: 'You can close this window.',
  },

  tours: {
    doneBtnText: 'Done',
    nextBtnText: 'Next →',
    prevBtnText: '← Previous',
    repeat: 'Repeat Tour',
    [WebTour.START_PAGE]: {
      icons: {
        title: 'Icons',
        description: 'There are different icons at the top of the page.',
      },
      language: {
        title: 'Language',
        description:
          'The first icon allows you to switch from <strong>German to English</strong>.',
      },
      user: {
        title: 'User Profile',
        description:
          'The <strong>User Profile</strong> section displays your personal information and assigned role',
      },
      userInformation: {
        title: 'User Information',
        description:
          'This section contains various information about the user. The user name, the user`s email address, the assigned role, and the task.',
      },
      logout: {
        title: 'Logout',
        description:
          '<strong>This icon</strong> is used for <strong>logging out</strong>',
      },
      overView: {
        title: 'Start Page',
        description:
          'On the start page of the <strong>Digitalization Projects</strong>, you will find various <strong>information</strong> and have the option to set various <strong>filters</strong>.',
      },
      projectOverView: {
        title: 'Project Overview',
        description:
          'This interface provides an overview of <strong>existing projects</strong>. These can be <strong>selected</strong> and <strong>opened</strong> here.',
      },
      filterOptions: {
        title: 'Filter Options',
        description:
          'Ther are <strong>three filter options</strong>. <strong>title</strong>, <strong>project pumber</strong> and <strong>project status</strong>.',
      },
      resetFilter: {
        title: 'Reset Filter',
        description:
          'These applied <strong>filters</strong> can also be <strong>removed</strong> again.',
      },
      addProject: {
        title: 'Add project',
        description:
          'To add a new project, click on this <strong>Button</strong> and enter all the information',
      },
    },
    [WebTour.PROJECT_DETAILS]: {
      overView: {
        title: 'Project Detail View',
        description: 'Welcome to the project detail view',
      },
    },
  },

  supplierAuthTokens: {
    createAuthToken: 'Create authentication token',
    createdAt: 'Created at',
    errors: {
      errorCreatingToken:
        'An error occured while creating the authentication token.',
      errorGettingTokens:
        'An error occured while loading the authentication tokens.',
      errorRevokingToken:
        'An error occured while revoking the authentication token.',
    },
    expirationDays: 'Expiration (days)',
    expired: 'Expired',
    expiresAt: 'Expires at',
    name: 'Name',
    revoke: 'Revoke token',
    revoked: 'Revoked',
    tokenCopied: 'The token was copied to the clipboard.',
    tokenCreated: 'The authentication token was successfully created.',
    tokenHint:
      'Please copy the token now. You will not be able to see it again!',
    tokenRevoked: 'The authentication token was successfully revoked.',
  },

  errorView: {
    [ErrorType.PROJECT_WITH_EXTERNAL_ID_NOT_FOUND]:
      'Project with external ID {externalProjectId} not found.',
  },

  uploadUpdateView: {
    errors: {
      errorGettingUploadData: 'An error occured while loading the upload data.',
      renditionRecordMissing:
        'For these document IDs no rendition file was added ' +
        'but the previous version of these ' +
        'documents had a rendition: {documentIds}',
      unknownFiles:
        'The following files were not part of the original upload. They cannot be uploaded.',
      uploadUpdateFailed: 'An error occured while updating the upload.',
    },
    updateUpload: 'Update upload {referenceNumber}',
    uploadUpdated: 'The upload was successfully updated.',
  },

  missingMainFilesModal: {
    description:
      'For the following documents, only a rendition file was provided. Only the rendition file will be uploaded:',
    missingMainFiles: 'Missing main files',
  },

  workspaces: {
    createWorkspace: 'Create workspace',
    errors: {
      errorGettingOwners: 'An error occured while loading the owners.',
      errorGettingReviewers: 'An error occured while loading the reviewers.',
      errorGettingWorkspaceDetails:
        'An error occured while loading the workspace details.',
      errorGettingWorkspaces: 'An error occured while loading the workspaces.',
    },
    name: 'Name',
    owners: 'Owners',
    reviewers: 'Reviewers',
    status: 'Status',
    statuses: {
      active: 'active',
      inactive: 'inactive',
    },
    workspaces: 'Workspaces',
    noOwnerSelected: 'No owners selected yet',
  },

  workspaceForm: {
    createWorkspace: 'Create workspace',
    durationStart: 'Anfang',
    durationEnd: 'Ende',
    errors: {
      errorCreatingWorkspace: 'An error occured while creating the workspace.',
      errorUpdatingWorkspace: 'An error occured while updating the workspace.',
      locationRequired: 'Location is required.',
      startDateRequired: 'Start date is required.',
      endDateRequired: 'End date date is required.',
      startDate: 'The start date must be on or before the end date',
    },
    location: 'Location',
    name: 'Name',
    status: 'Status',
    workspaceCreated: 'The workspace was successfully created.',
    workspaceUpdated: 'The workspace was successfully updated.',
    workspaceStatus: {
      [WorkspaceStatus.ACTIVE]: 'active',
      [WorkspaceStatus.INACTIVE]: 'inactive',
    },
  },

  workspaceDetailsTabs: {
    [WorkspaceDetailsTab.SETTINGS]: 'Settings',
    [WorkspaceDetailsTab.GROUPS]: 'Groups',
    [WorkspaceDetailsTab.DOCUMENTS]: 'Documents',
    [WorkspaceDetailsTab.DCC_FULFILLMENT]: 'DCC Fulfillment',
    [WorkspaceDetailsTab.IBL]: 'IBL',
  },

  workspaceDocuments: {
    title: 'Documents',
    preview: 'Preview',
    embeddedTabs: {
      editable: 'Editable Documents',
      readOnly: 'Read-only Documents',
    },
    columnTitle: 'Title',
    dcc: 'Document class (DCC)',
    kks: 'KKS',
    uploadDocument: 'Upload document',
    addForEditing: 'Add for editing',
    addForViewing: 'Add for viewing',
    selectContentTypeTitle: 'Select content type',
    selectContentTypePlaceholder: 'Content type',
    singleUploadTitle: 'Single upload',
    renditionFilePresent: 'Rendition file',
    involvementType: 'Involvement type',
    documentId: 'Document ID',
    version: 'Version',
    createDate: 'Upload date',
    lastModified: 'Last modified',
    groupName: 'Group name',
    workflowStatus: 'Workflow status',
    errors: {
      noContentTypeSelected: 'Please select a content type.',
      kksNotInScope: 'One or more KKS are outside your KKS scope.',
      errorGettingDocuments: 'An error occured while loading documents.',
    },
    picker: {
      addForEditing: 'Add for editing',
      addForViewing: 'Add for viewing',
      workingCopiesCreated: '{count} document(s) added for editing',
      readOnlyAdded: '{count} document(s) added for viewing',
      search: 'Search',
      searchButton: 'Search',
      filters: 'Filters',
      applyFilters: 'Apply filters',
      noResults: 'No documents found',
      notPresent: 'not present',
      selectionDone: '{count} document(s) selected',
      stationNumber: 'Station number',
      kks: 'KKS',
      dcc: 'Document class (DCC)',
      folderNumber: 'Folder number',
      documentNumber: 'Document/drawing number',
      lastModifiedBy: 'Last modified by',
      refiners: {
        docLanguage: 'Language',
        stationNumber: 'Station number',
        sourceSystem: 'Source system',
        responsibleArea: 'Responsible area',
        processStatus: 'Process status',
        docStatus: 'Document status',
      },
      disabledReasons: {
        alreadyAddedToWorkspaceEditable:
          'This document has already been added to this workspace for editing.',
        alreadyAddedToOtherWorkspaceEditable:
          'This document is already added for editing in another workspace.',
        invalidEditableStatus:
          'This document can only be added for editing when its document status is "{statusLabel}".',
        alreadyAddedToWorkspaceReadOnly:
          'This document has already been added to this workspace as read-only.',
      },
      errors: {
        createWorkingCopiesFailed:
          'An error occured while creating working copies.',
        addReadOnlyFailed:
          'An error occured while adding read-only documents to workspace.',
        kksNotInScope:
          'You do not have access to any KKS assigned to one or more ' +
          'selected documents.',
        searchFailed: 'An error occured while searching documents.',
      },
    },
  },

  workspaceDocumentInvolvementType: {
    [WorkspaceDocumentInvolvementType.CREATED]: 'New document',
    [WorkspaceDocumentInvolvementType.CHECKED_OUT]: 'Editing access',
  },

  workspaceOwnersManagement: {
    addOwner: 'Add owner',
    cannotRemoveLastOwner:
      'The last owner cannot be removed from the workspace.',
    selectOwner: 'Select owner',
    errors: {
      errorAddingOwner:
        'An error occured while adding the owner to the workspace.',
      errorGettingOwnerCandidates:
        'An error occured while loading the available owners.',
      ownerAlreadyAdded: 'This owner was already added to this workspace.',
      ownerSelectionRequired: 'Please select an owner.',
      errorGettingOwners:
        'An error occured while loading the owners of the workspace.',
      errorRemovingOwner:
        'An error occured while removing the owner from the workspace.',
    },
    ownerAdded: 'The owner was successfully added to the workspace.',
    ownerRemoved: 'The owner was successfully removed from the workspace.',
    owners: 'Owners',
  },

  workspaceReviewersManagement: {
    addReviewer: 'Add reviewer',
    selectReviewer: 'Select reviewer',
    errors: {
      errorAddingReviewer:
        'An error occured while adding the reviewer to the workspace.',
      errorGettingReviewerCandidates:
        'An error occured while loading the available reviewers.',
      reviewerAlreadyAdded:
        'This reviewer was already added to this workspace.',
      reviewerSelectionRequired: 'Please select a reviewer.',
      errorRemovingReviewer:
        'An error occured while removing the reviewer from the workspace.',
    },
    reviewerAdded: 'The reviewer was successfully added to the workspace.',
    reviewerRemoved:
      'The reviewer was successfully removed from the workspace.',
    reviewers: 'Reviewers',
  },

  workspaceGroupsManagement: {
    addGroup: 'Add group',
    groups: 'Workspace groups',
    groupName: 'Group name',
    groupNamePlaceholder: 'Enter group name',
    name: 'Name',
    usersCount: 'Users count',
    errors: {
      groupNameNotUnique: 'A workspace group with this name already exists.',
      groupNameRequired: 'Please enter a group name.',
      errorGettingGroups:
        'An error occured while loading the workspace groups.',
      errorGettingGroupUsers:
        'An error occured while loading the workspace group users.',
      errorCreatingGroup:
        'An error occured while creating the workspace group.',
      errorValidatingGroupName:
        'An error occured while validating the group name.',
      errorAddingUser:
        'An error occured while adding the user to the workspace group.',
      errorRemovingUser:
        'An error occured while removing the user from the workspace group.',
    },
    groupCreated: 'The workspace group was successfully created.',
    userAdded: 'The user was successfully added to the workspace group.',
    userRemoved: 'The user was successfully removed from the workspace group.',
  },

  workspaceGroupDetailView: {
    users: 'Users',
    permissions: 'Permission scope',
    selectUser: 'Select User',
    userSelectionRequired: 'Please select an user.',
    errors: {
      couldNotGetUsers: 'An error occured while loading Active Directory users',
    },
  },

  workspaceGroupUsers: {
    addUser: 'Add user',
    users: 'Users',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    errors: {
      userAlreadyInGroup: 'This user is already in this workspace group.',
      userAlreadyInAnotherGroup:
        'This user is already in another workspace group in this workspace.',
    },
  },

  workspaceGroupPermissions: {
    title: 'KKS scope',
    description:
      'Set a KKS node to grant group members write access to documents under that node.',
    kksSelectorLabel: 'Start KKS',
    remove: 'Remove',
    errors: {
      errorGettingKksRange: 'An error occured while loading the KKS range.',
      errorSavingKksRange: 'An error occured while saving the KKS range.',
      errorRemovingKksRange: 'An error occured while removing the KKS range.',
    },
    success: {
      kksRangeSaved: 'The KKS range was successfully saved.',
      kksRangeRemoved: 'The KKS range was successfully removed.',
    },
  },

  workflowStatus: {
    [WorkflowStatus.IN_PROGRESS]: 'In progress',
    [WorkflowStatus.IN_REVIEW]: 'In review',
    [WorkflowStatus.APPROVED]: 'Approved',
  },

  workspaceDocumentStatusIndicator: {
    actions: {
      setInReview: 'Move to in review',
      approve: 'Approve',
    },
    success: {
      setInReview: 'The document status was updated to in review.',
      approve: 'The document was approved.',
    },
    errors: {
      cannotSetInReview: 'The document could not be moved to in review.',
      cannotApprove: 'The document could not be approved.',
    },
  },

  useWorkspaceKks: {
    errors: {
      errorCheckingKksAccess:
        'An error occured while checking the KKS access permissions.',
    },
  },

  dccFulfillmentTable: {
    hint: 'This table shows the DCC fulfillment for all KKS that require specific document classes in this workspace. Each row shows the current number of matching documents versus the required target.',
    title: 'DCC Fulfillment',
    columns: {
      kks: 'KKS',
      fulfillment: 'Fulfillment (current / target)',
    },
    errors: {
      cannotLoadFulfillment:
        'An error occured while loading the DCC fulfillment.',
    },
    emptyMessage: 'No KKS with specific fulfillment found.',
  },

  dccProposalsCell: {
    applyTo: 'Apply to:',
    masterDcc: 'Master DCC',
    contentDcc: 'Content DCC',
    aiDccCheck: 'DCC GenAI',
    dccProposalCheck: 'DCC Proposal',
    noMatchingValue: 'No valid DCC',
    alreadyExists: 'DCC already exists in {field}',
  },
};
